import { render } from "./CropTable.vue?vue&type=template&id=02d4bc25&scoped=true"
import script from "./CropTable.vue?vue&type=script&lang=js"
export * from "./CropTable.vue?vue&type=script&lang=js"

import "./CropTable.vue?vue&type=style&index=0&id=02d4bc25&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d4bc25"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
